// extracted by mini-css-extract-plugin
export default {"newsContainer":"News_newsContainer__W7wvV","cardList":"News_cardList__2QYY6"};